import React, { useState } from 'react';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';

interface EntityHubCardSummaryProps {
  text: string;
  as?: 'p' | 'span';
  label: string;
  children?: React.ReactNode;
}

const EntityHubCardSummary: React.FC<EntityHubCardSummaryProps> = ({
  text,
  as = 'p',
  label,
  children,
}) => {
  const [expanded, setExpanded] = useState(false);
  const copyClassName = `entity-hub-card-summary${expanded ? ' expanded' : ''}`;

  return (
    <div className='entity-hub-card-summary-wrap'>
      {as === 'span' ? (
        <span className={copyClassName}>{text}</span>
      ) : (
        <p className={copyClassName}>{text}</p>
      )}
      <button
        type='button'
        className='entity-hub-card-copy-toggle'
        aria-expanded={expanded}
        aria-label={`${expanded ? 'Show less' : 'Show more'} ${label}`}
        onClick={() => setExpanded((value) => !value)}
      >
        {expanded ? 'View less' : 'View more'}
        <KeyboardArrowDownOutlinedIcon
          className={expanded ? 'expanded' : ''}
          sx={{ fontSize: 16 }}
        />
      </button>
      {expanded && children ? (
        <div className='entity-hub-card-summary-details'>{children}</div>
      ) : null}
    </div>
  );
};

export default EntityHubCardSummary;
